const Education_Api = [
    {
      id: 1,
      category: "education",
      year: "Goa University (2013 - 2016)",
      title: "Bachelor of Computer Applications (BCA)",
      desc: "Shree Damodar College Of Commerce & Economics",
      rate: "87.7%",
    },
    {
      id: 2,
      category: "experience",
      year: "Bangalore University (2016 - 2019) ",
      title: "Master of Computer Applications (MCA)",
      desc: "Jyoti Nivas College Autonomous",
      rate: "78.5%",
    },
  ]
  
  export default Education_Api
  